export const errorMsgs: Record<string, string> = {
	ACCOUNT_NOT_FOUND: ' Tài khoản hoặc mật khẩu không chính xác!',
};